import api from './api';

class CreditService {
  async getById(id) {
    return api
      .get(`/credits/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        console.log(
          `fail when trying to get credit with id ${id} in CreditService.`,
          error.response?.data?.error,
        );
        throw error.response?.data?.error;
      });
  }

  async create(creditForm) {
    return api
      .post('/credits', creditForm)
      .then((response) => response.data)
      .catch((error) => {
        console.log(
          'fail when trying to create credit in CreditService.',
          error.response?.data?.error,
        );
        throw error.response?.data?.error;
      });
  }

  async getAllCredits() {
    return api
      .get('/credits')
      .then((response) => response.data)
      .catch((error) => {
        console.log(
          'fail when trying to get credits in CreditService.',
          error.response?.data?.error,
        );
        throw error.response?.data?.error;
      });
  }

  async remove(id) {
    return api
      .delete(`/credits/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        console.log(
          `fail when trying to remove credit with id ${id} in CreditService.`,
          error.response?.data?.error,
        );
        throw error.response?.data?.error;
      });
  }

  async update(creditForm) {
    return api
      .put(`/credits`, creditForm)
      .then((response) => response.data)
      .catch((error) => {
        console.log(
          `fail when trying to update credit with id ${creditForm.clientId} in CreditService.`,
          error.response?.data?.error,
        );
        throw error.response?.data?.error;
      });
  }

  async hasCreditWithField(field, value) {
    return api
      .head(`/credits/exists/${field}/${value}`)
      .then(() => true)
      .catch((error) => {
        if (error.response?.status === 404) {
          return false;
        }
        console.log(
          `fail when trying to check existence of credit with ${field}=${value} in CreditService.`,
          error.response?.data?.error,
        );
        throw error.response?.data?.error;
      });
  }
}

const creditService = new CreditService();
export default creditService;
